<template>
    <div class="ext-left-nav-box">
        <h2>订单中心</h2>
        <ul>
            <li v-for="(vo,index) in order_nav" :key="index" :class="[vo.url==select_nav ? 'select' : '']">
                <router-link :to="{path:vo.url,query:{}}">{{vo.title}}</router-link>
            </li>
        </ul>
        <h2>餐厅信息</h2>
        <ul>
            <li v-for="(vo,index) in store_nav" :key="index" :class="[vo.url==select_nav ? 'select' : '']">
                <router-link :to="{path:vo.url,query:{}}">{{vo.title}}</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import {getCompanyNo} from '@/utils/extend'
export default {
  name: 'ExtNav',
  data () {
    return {
      select_nav: '',
      company_no: getCompanyNo(),
      order_nav: [],
      store_nav: []
    }
  },
  mounted () {
    var path = this.$route.path
    this.select_nav = path

    if (this.company_no === 'MCD-CHN') {
      this.store_nav = [
        {
          id: '3',
          title: '我的资料',
          url: '/store/store_info'
        }, {
          id: '4',
          title: '我的收藏',
          url: '/store/collect'
        }, {
          id: '5',
          title: '浏览记录',
          url: '/store/browse'
        }, {
          id: '7',
          title: '积分明细',
          url: '/store/integral'
        },
        {
          id: '13',
          title: '我的账单',
          url: '/store/store_bill'
        }, {
          id: '12',
          title: 'VIP会员',
          url: '/store/vip_info'
        }, {
          title: '优惠券',
          url: '/store/coupons'
        }, {
          id: '8',
          title: '联系客服',
          url: '/store/customer_service'
        }, {
          id: '9',
          title: '我的评价',
          url: '/store/evaluate'
        }, {
          id: '10',
          title: '意见反馈',
          url: '/store/feedback'
        }, {
          id: '11',
          title: '我的消息',
          url: '/store/message'
        }
      ]

      this.order_nav = [
        {
          id: '1',
          title: '我的订单',
          url: '/order/order_list'
        },
        {
          id: '2',
          title: '退货订单',
          url: '/order/return_order_list'
        }
      ]
    } else {
      this.store_nav = [
        {
          id: '3',
          title: '我的资料',
          url: '/store/store_info'
        }, {
          id: '4',
          title: '我的收藏',
          url: '/store/collect'
        }, {
          id: '5',
          title: '浏览记录',
          url: '/store/browse'
        }, {
          id: '8',
          title: '联系客服',
          url: '/store/customer_service'
        }, {
          id: '10',
          title: '意见反馈',
          url: '/store/feedback'
        }, {
          id: '11',
          title: '我的消息',
          url: '/store/message'
        }
      ]

      this.order_nav = [
        {
          id: '1',
          title: '我的订单',
          url: '/order/order_list'
        }
      ]
    }
  },
  methods: {

  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }

.ext-left-nav-box { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; border:1px solid #dfdfdf; align-content:flex-start;}
    .ext-left-nav-box h2 { width:100%; height:40px; line-height:40px; padding:0px 15px; margin:0px; font-size:16px; font-weight: bold; color:#333333;}
    .ext-left-nav-box ul { width:100%; height:auto; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
    .ext-left-nav-box ul li { width:100%; border-left:3px solid #ffffff; height:auto; cursor: pointer; line-height:35px; padding:0px 15px; color:#333333; font-size:14px; margin:0px;}
    .ext-left-nav-box ul li a { width:100%; height:35px; line-height:35px; color:#333333;}
    .ext-left-nav-box ul li a:hover { color:#333333;}
    .ext-left-nav-box ul li.select { border-left:3px solid #d81e06; background: #fbe1df;}
    .ext-left-nav-box ul li:hover { border-left:3px solid #d81e06; background: #fbe1df;}
</style>



// WEBPACK FOOTER //
// src/components/leftnav/index.vue